import { render } from "./SelectStato.vue?vue&type=template&id=293f58e2&ts=true"
import script from "./SelectStato.vue?vue&type=script&lang=ts"
export * from "./SelectStato.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__